import { useMutation } from "@tanstack/react-query"
import { initiatePayment } from "../infrastructure/subscription.api"
import { redirectToPayFast } from "../infrastructure/payfast-redirect"

export function useInitiateSubscriptionPayment() {
  return useMutation({
    mutationFn: (subscriptionId: string) => initiatePayment(subscriptionId),
    onSuccess: ({ paymentRedirect }) => {
      redirectToPayFast(paymentRedirect.redirectUrl, paymentRedirect.formData)
    },
  })
}
